<template>
  <v-layout justify-start align-center row style="width: 100%" class="bottom-trip-info">
    <!-- <p>ETA - 8mins</p>
    <p>DRIVER - Moynul Chaudhury (11)</p>-->
    <p>Dist - {{ distanceMiles() }}</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;Dur - {{ distanceHoursMinutes }}</p>
    <p
      v-if="bestDriver"
    >&nbsp;&nbsp;&nbsp;&nbsp;Driver - {{ bestDriver.callsign }} {{ bestDriver.name }} ({{ bestDriver.minutesFromPickup }} mins)</p>
  </v-layout>
</template>

<script>
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "BookingTripETARoute",
  model: {
    prop: "content",
    event: "input"
  },
  components: {},
  props: {
    bookingForm: Object
  },
  computed: {
    bestDriver: function() {
      return this.bookingForm.booking.bestDriver;
    },
    distanceHoursMinutes: function() {
      if (this.bookingForm.booking.route.time == null) {
        return "";
      }

      return this.minutesToHoursMinutesString(
        this.bookingForm.booking.route.time
      );
    }
  },
  data() {
    return {};
  },
  methods: {
    distanceMiles: function() {
      console.log("Distance miles");
      console.log(this.bookingForm.booking.route);

      if (this.bookingForm.booking.route.distance_in_miles == null) {
        return "Unknown";
      }

      return this.bookingForm.booking.route.distance_in_miles.toFixed(1) + "mi";
    },
    durationToHoursMinutesString: function(duration, minutesString) {
      return Overwatch.durationToHoursMinutesString(duration, minutesString);
    },
    minutesToHoursMinutesString: function(minutes) {
      var duration = moment.duration(minutes, "minutes");

      var hoursMinutesString = this.durationToHoursMinutesString(duration, "m");

      return hoursMinutesString;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
